import { EmptyState, PageHeader, Skeleton } from '@portals-platform/ui';
import { FileBarChartIcon, LockIcon } from 'lucide-react';
import { PortalShell } from '../components/portal-shell.js';
import { useCanViewReports } from '../data-access/index.js';

function ReportsBody() {
  const { canViewReports, isLoading } = useCanViewReports();

  if (isLoading) {
    return <Skeleton className="h-48 w-full" />;
  }

  if (!canViewReports) {
    return (
      <EmptyState
        icon={<LockIcon />}
        title="You don't have access to reports"
        description="Reports are available to users with the reporting role. Ask an administrator to grant it."
      />
    );
  }

  return (
    <EmptyState
      icon={<FileBarChartIcon />}
      title="Reports coming soon"
      description="Exportable compliance reports, audit logs, and scheduled report delivery will appear here."
    />
  );
}

export function ReportsPage() {
  return (
    <PortalShell activeId="reports" pageTitle="Reports">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Reports"
          description="Generate and download compliance and audit reports."
        />
        <ReportsBody />
      </div>
    </PortalShell>
  );
}
